const useTournamentTooltip = () => {
  const getTooltipPosition = (
    tooltipPosition?: 'bottom-start' | 'bottom-end',
    isCurrentTournaments?: boolean,
  ) => {
    if (tooltipPosition) {
      return tooltipPosition;
    }
    if (isCurrentTournaments) {
      return 'bottom-end';
    }
    return 'bottom-center';
  };
  return { getTooltipPosition };
};

export default useTournamentTooltip;
